import script from "./MemberInvitationsList.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberInvitationsList.vue?vue&type=script&setup=true&lang=js"

import "./MemberInvitationsList.vue?vue&type=style&index=0&id=357bd990&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-357bd990"]])

export default __exports__